// extracted by mini-css-extract-plugin
module.exports = {"packGrid":"packGrid-module--packGrid--1OcJJ","packContainer":"packGrid-module--packContainer--3SPxO"};